module.exports = __webpack_public_path__ + "img/tra-cuu-icon.6815fd44.svg";